
import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext } from "@/script/core/base/ServiceData";
import {
  createNodeContext,
  createWarnContext,
} from "@/script/apps/recon/config/ReconConfig";
import { Warn } from "@/script/apps/recon/entity/ReconEntity";
import { DictUtil } from "@/script/core/Dict";
import { DictService } from "@/script/apps/system/service/DictService";
import { Dict } from "@/script/apps/system/entity/SystemEntity";

@Options({})
export default class WarnList extends BaseList {
  private queryEntity: Warn = {};
  private dataList: Warn[] = [];
  private nodeList: Node[] = [];
  private dateRange: string[] = [];
  private dataStates: Dict[] = [];
  private submitStates: Dict[] = [];

  public initData(): ServiceContext {
    return createWarnContext();
  }

  public initQueryEntity() {
    this.queryEntity = {
      name: "",
    };
    return this.queryEntity;
  }

  protected initOptions() {
    super.initOptions();
    createNodeContext().service.loadFullList<Node[]>((data: Node[]) => {
      this.nodeList = data;
    });
    const dictService = new DictService();
    dictService.loadChildItems("rec-warn-data-state", (data: any) => {
      this.dataStates = data;
    });
    dictService.loadChildItems("rec-warn-submit-state", (data: any) => {
      this.submitStates = data;
    });
  }

  public beforeLoadList() {
    if (this.queryEntity.state === "") {
      this.queryEntity.state = null;
    }
    if (this.dateRange && this.dateRange.length > 0) {
      this.dateRange[1] = this.dateRange[1].replace("00:00:00", "23:59:59");
      this.queryParam.extendMap = {
        beginTime: this.dateRange[0],
        endTime: this.dateRange[1],
      };
    } else {
      this.queryParam.extendMap = {};
    }
  }

  public afterLoadList(data: any): void {
    const currDataList: Warn[] = data.list as Warn[];
    currDataList.forEach((item) => {
      item.dataStateName = DictUtil.getItemName(
        this.dataStates,
        String(item.dataState)
      );
      item.submitStateName = DictUtil.getItemName(
        this.submitStates,
        String(item.submitState)
      );
    });
    this.dataList = currDataList;
  }
}
